import { UTILS__ml_asset } from '@/utils/UTILS__ml_asset';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { G_TABLE__inputs__base } from '../_base/G_TABLE__inputs__base';
import { HOOK_TABLE_LAYOUT__inputs__model } from './HOOK_TABLE_LAYOUT__inputs__model';

interface PROPS {
  fields: FIELD_PRIMITIVE__string_hash_ml_asset[];
}

export function G_TABLE__inputs__model({ fields }: PROPS) {
  const columns = HOOK_TABLE_LAYOUT__inputs__model({ fields });

  function sort_fields(a: FIELD_PRIMITIVE__string_hash_ml_asset, b: FIELD_PRIMITIVE__string_hash_ml_asset) {
    let [name_a, version_a] = UTILS__ml_asset.get_name_and_version(a.get_value());
    let [name_b, version_b] = UTILS__ml_asset.get_name_and_version(b.get_value());

    if (b.ml_asset_type == a.ml_asset_type) return name_a.localeCompare(name_b);

    return a.ml_asset_type.localeCompare(b.ml_asset_type);
  }

  fields.sort(sort_fields);

  return <G_TABLE__inputs__base {...{ columns }} title={'MODELS'} fields={fields} />;
}
